import { compose } from 'redux';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { UserCardDefault } from 'ha/components.legacy/Cards/UserCardDefault';
import { getAdvertiser } from '../selectors';

const enhance = compose(
  connect(
    createStructuredSelector({
      user: getAdvertiser,
      showDescription: () => false,
    }),
  ),
);

// @ts-ignore
const ListingAdvertiserCard = enhance(UserCardDefault);
export { ListingAdvertiserCard };
